<template>
  <div>
    <mia-notice
      permanent
      class="mb-8"
    >
      <p class="my-0">
        Einstellungen für Fahrzeugbörsen wie <b>mobile.de</b> und <b>JuhuAuto</b> könnten in den <router-link :to="{ name: 'settings.basics.publishing' }">
          Veröffentlichungs-Einstellungen
        </router-link> vorgenommen werden.
      </p>
    </mia-notice>

    <mia-dealer-feature-notice
      class="mb-6"
      :feature="{
        cars_advanced: !isB2u && !authDealer.item_is_allowed_cars_advanced,
        vap: !authDealer.item_is_allowed_vap,
      }"
    />

    <mia-settings-basics-services-dat-form
      v-if="!isB2u && authDealer.item_is_allowed_cars_advanced"
      class="mb-16"
    />
    <mia-has-feature feature="removebg">
      <mia-settings-basics-services-remove-bg-form class="mt-16" />
    </mia-has-feature>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DealerFeatureNotice from '@/components/cars/edit/DealerFeatureNotice.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import ServicesDatForm from '@/components/settings/forms/ServicesDatForm.vue'
import ServicesRemoveBgForm from '@/components/settings/forms/ServicesRemoveBgForm.vue'

export default {
  name: 'MiaSettingsBasicsServices',

  components: {
    'mia-dealer-feature-notice': DealerFeatureNotice,
    'mia-notice': Notice,
    'mia-settings-basics-services-dat-form': ServicesDatForm,
    'mia-settings-basics-services-remove-bg-form': ServicesRemoveBgForm
  },

  computed: {
    ...mapGetters('settings', ['isB2u'])
  }
}
</script>
